// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#addBudgetRequestsModal .txt-add {
  padding-top: 1.6rem;
  padding-bottom: 1.12rem;
  max-width: 200px;
  margin: 0 auto;
}
#addBudgetRequestsModal .selectPlant {
  padding: 2px 0;
  min-width: 145px;
}
#addBudgetRequestsModal .fileupload {
  opacity: 0;
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
}
#addBudgetRequestsModal .border-right {
  border-right: 1px solid #e8e1e1;
}
#addBudgetRequestsModal .icon-add {
  color: #0078dc;
  font-size: 4.8rem;
  padding-right: 0;
}
#addBudgetRequestsModal label {
  margin-bottom: 0;
}
#addBudgetRequestsModal .btn {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#addBudgetRequestsModal .btn-link {
  color: #5b5b5b;
  font-weight: bold;
}
#addBudgetRequestsModal .btn-link:hover {
  text-decoration: none;
  color: #5a5a5a;
}
#addBudgetRequestsModal .btn-link:focus {
  text-decoration: none;
}
#addBudgetRequestsModal .btn-secondary {
  border-radius: 0;
  background-color: #b4b4b4;
  box-shadow: none !important;
  border: none;
}
#addBudgetRequestsModal .btn-primary {
  border-radius: 30px;
  min-width: 200px;
  box-shadow: none !important;
}
@media (min-width: 2024px) {
#addBudgetRequestsModal #confirmation-modal-label {
    font-size: 3.2rem;
}
}
@media (min-width: 2024px) {
#addBudgetRequestsModal .invalid-feedback span {
    font-size: 1.84rem !important;
}
}
#addBudgetRequestsModal .duplicate .wrapper-icon .icon-info {
  border: 2px solid #adadad;
  padding: 3px;
  font-size: 18px;
  border-radius: 18px;
  width: 18px;
  color: #adadad;
  cursor: pointer;
}
#addBudgetRequestsModal .duplicate .col-md-12 {
  margin-bottom: 0;
}
#addBudgetRequestsModal .duplicate label {
  font-size: 1.44rem;
}
@media (min-width: 2024px) {
#addBudgetRequestsModal .modal-dialog {
    max-width: 700px !important;
}
}
@media (min-width: 2024px) {
#addBudgetRequestsModal .modal-dialog .input-group input {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#addBudgetRequestsModal .modal-dialog .modal-footer button.btn {
    font-size: 1.84rem !important;
}
}
@media (max-width: 767px) {
#addBudgetRequestsModal .border-right {
    border-right: none !important;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
